import DegreeOfEducation from '@/views/Settings/DegreeOfEducation';
import HouseTypes from '@/views/Settings/HouseTypes';
import Employment from '@/views/Settings/Employment';
import WhoIsThisPerson from '@/views/Settings/WhoIsThisPerson';
import Banks from '@/views/Settings/Banks';
import WorkPositions from '@/views/Settings/WorkPositions';
import Accounts from '@/views/Settings/Accounts';
import { requiresAdminAccess } from '@/router/helpers';

export default [
  {
    path: '/settings/degrees-of-education',
    name: 'DegreeOfEducation',
    component: DegreeOfEducation,
    beforeEnter: requiresAdminAccess,
    meta: {
      group: 'settings',
      roles: ['ADMINISTRATOR'],
      title: 'Боловсролын зэрэг',
    },
  },
  {
    path: '/settings/house-types',
    name: 'HouseTypes',
    component: HouseTypes,
    beforeEnter: requiresAdminAccess,
    meta: {
      group: 'settings',
      roles: ['ADMINISTRATOR'],
      title: 'Орон сууцны төрөл',
    },
  },
  {
    path: '/settings/employment',
    name: 'Employment',
    component: Employment,
    beforeEnter: requiresAdminAccess,
    meta: {
      group: 'settings',
      roles: ['ADMINISTRATOR'],
      title: 'Ажил эрхлэлт',
    },
  },
  {
    path: '/settings/who-is-this-person',
    name: 'WhoIsThisPerson',
    component: WhoIsThisPerson,
    beforeEnter: requiresAdminAccess,
    meta: {
      group: 'settings',
      roles: ['ADMINISTRATOR'],
      title: 'Хэн бэ энэ хүн вэ?',
    },
  },
  {
    path: '/settings/banks',
    name: 'Banks',
    component: Banks,
    beforeEnter: requiresAdminAccess,
    meta: {
      group: 'settings',
      roles: ['ADMINISTRATOR'],
      title: 'Банк',
    },
  },
  {
    path: '/settings/work-positions',
    name: 'WorkPositions',
    component: WorkPositions,
    beforeEnter: requiresAdminAccess,
    meta: {
      group: 'settings',
      roles: ['ADMINISTRATOR'],
      title: 'Ажил эрхлэлт',
    },
  },
  {
    path: '/settings/accounts',
    name: 'Accounts',
    component: Accounts,
    beforeEnter: requiresAdminAccess,
    meta: {
      group: 'settings',
      roles: ['ADMINISTRATOR'],
      title: 'Данс',
    },
  },
];
